<template>
	<div class="modal fade" id="updateRoleClaim" role="dialog" aria-labelledby="updateRoleClaimLabel" aria-hidden="true">
		<div class="modal-dialog modal-xl" role="document" data-backdrop="static">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="updateRoleClaimLabel">{{ `${model.claimName} - ${model.claimLabel}` }}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="loader" v-if="isSaving"></div>
				<div class="modal-body">
                    <kendo-editor v-model="model.description"
                          :resizable-content="true"
                          :resizable-toolbar="true"
                          :id="'claimDetails' + _uid"
                          :name="'claimDetails' + _uid"
                          rows="50"
                          style="height: 600px">
                    </kendo-editor>
					<div class="row">
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success" @click.stop="onSave">
                        <i class="fas fa-save mr-2"></i>
                        {{$t("buttons.save.btnText")}}
                    </button>
                    <button class="btn btn-danger" @click="hide">
                        <i class="fas fa-ban mr-2"></i>
                        {{$t("buttons.close")}}
                    </button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { EditorInstaller } from '@progress/kendo-editor-vue-wrapper'

Vue.use(EditorInstaller)

export default {
    name: 'UpdateRoleClaimComponent',
	components: {

	},
	props: {
		value: {
			type: Object,
			required: false
		},
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			model: {},
			isSaving: false,
			statuses: []
		};
	},
	methods: {
		onSave(e) {
			e.preventDefault();

			this.$validator.validate().then(valid => {
				if (valid) {
					this.save();
				}
			});
		},
		save() {
			this.isSaving = true;

			this.$http
				.put('/api/participantsClaims/updateClaimDescription', { claimId: this.model.claimId, description: this.model.description })
				.then(result => {
					this.$vs.notify({
						color: 'success',
						title: this.$t('updateSuccess'),
						text: ''
					});
					this.$emit('updated', this.model);
				})
				.catch(err => {
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$t('notifications.serverError')
					});
				})
				.finally(() => {
					this.hide();
				});
		},
		onClose() {
			this.$emit('onClose', { ...this.model });
			this.model = {};
			this.isSaving = false;
			this.$validator.reset();
		},
		hide() {
			$(this.$el).modal('hide');
		}
	},
	mounted() {
		$(this.$el).on('hidden.bs.modal', this.onClose);
	},
	beforeDestroy() {
		$(this.$el).off('hidden.bs.modal');
	},
	watch: {
		show: function(val) {
			if (val) {
				this.model = this.value;
				$(this.$el).modal('show');
			} else {
				$(this.$el).modal('hide');
			}
		}
	}
};
</script>

<style>
</style>
